import { PAYMENTS_SUBSCRIPTIONS_ROUTES } from '@hotmart/hub-components'

const menu = {
  main: '/main',
  profile: '/my_account',
  purchase: '/purchase',
  cancelled: '/purchase/cancelled',
  creator: '/creator'
}

const purchase = {
  main: '/main',
  purchases: '/purchase',
  purchaseModal: '/purchase/:id',
  purchasesArchived: '/purchase/archived',
  invoice: '/invoice',
  cancelled: '/purchase/cancelled'
}

const authRoot = '/auth'

const auth = {
  logout: `${authRoot}/logout_internal`,
  login: `${authRoot}/login`,
  renew: `${authRoot}/renew`,
  surrogate: `${authRoot}/surrogate`
}

const RootProfile = '/my_account'

const profile = {
  main: RootProfile,
  profile: `${RootProfile}/profile`,
  password: `${RootProfile}/password`,
  privacy: `${RootProfile}/privacy`,
  device: `${RootProfile}/device`
}

const event = {
  checkinAuth: '/purchase/checkin/*',
  checkinUnauth: '/eticket/:checkinId/*',
  ticketUpgrade: '/ticket_upgrade/:purchaseId/:productId'
}

const paymentsSubscription = PAYMENTS_SUBSCRIPTIONS_ROUTES

const access = {
  main: '/access/:transactionCode'
}

export default { menu, auth, profile, purchase, event, paymentsSubscription, access }
